import { render, staticRenderFns } from "./LeaveDetailsTab.vue?vue&type=template&id=4b2748bc"
import script from "./LeaveDetailsTab.vue?vue&type=script&lang=js"
export * from "./LeaveDetailsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports